/**
 * Stockage des tokens d'authentification pour "Se souvenir de moi".
 * - rememberMe = true  → localStorage : session persistante après fermeture du navigateur
 * - rememberMe = false → sessionStorage : session limitée à l'onglet/fenêtre
 */
const STORAGE_TYPE_KEY = 'auth_storage_type';
const ACCESS_KEY = 'access_token';
const REFRESH_KEY = 'refresh_token';

export type AuthStorageType = 'local' | 'session';

export function getAuthStorage(): Storage {
  if (typeof window === 'undefined') return localStorage;
  const sessionType = sessionStorage.getItem(STORAGE_TYPE_KEY);
  if (sessionType === 'session') return sessionStorage;
  return localStorage;
}

export function setAuthStorageType(rememberMe: boolean): void {
  const type: AuthStorageType = rememberMe ? 'local' : 'session';
  const storage = type === 'local' ? localStorage : sessionStorage;
  storage.setItem(STORAGE_TYPE_KEY, type);
}

export function getAccessToken(): string | null {
  return getAuthStorage().getItem(ACCESS_KEY);
}

export function getRefreshToken(): string | null {
  return getAuthStorage().getItem(REFRESH_KEY);
}

export function setTokens(access: string | null, refresh: string | null, rememberMe: boolean): void {
  setAuthStorageType(rememberMe);
  const storage = rememberMe ? localStorage : sessionStorage;
  const otherStorage = rememberMe ? sessionStorage : localStorage;
  if (access) {
    storage.setItem(ACCESS_KEY, access);
    otherStorage.removeItem(ACCESS_KEY);
  } else {
    storage.removeItem(ACCESS_KEY);
    otherStorage.removeItem(ACCESS_KEY);
  }
  if (refresh) {
    storage.setItem(REFRESH_KEY, refresh);
    otherStorage.removeItem(REFRESH_KEY);
  } else {
    storage.removeItem(REFRESH_KEY);
    otherStorage.removeItem(REFRESH_KEY);
  }
}

export function clearTokens(): void {
  [localStorage, sessionStorage].forEach((s) => {
    s.removeItem(ACCESS_KEY);
    s.removeItem(REFRESH_KEY);
    s.removeItem(STORAGE_TYPE_KEY);
  });
}
